import * as React from 'react';
import { IActions, actionCreator } from './store/action/creators';
import { actionCreator as authActions } from '../../common/Auth0/store/actions/creators';
import { Grid, StyledComponentProps } from '@material-ui/core';
import { IApplicationState } from '../../store/ApplicationState';
import { connect } from 'react-redux';
import Paper from '../../ui-components/Containers/Paper';
import { withStyles } from '@material-ui/core/styles';
import { styles } from './styles';
import { WithMediaQuery, IMediaQueryProps } from '../../layout/withMediaQuery';
import { IState } from './store/state';
import { reservation, reservationRoom, reservationSlot } from '../../model/reservation';
import Filters from './components/Filters';
import { SelectItem } from '../../ui-components/select/Select';
import moment from 'moment';
import ReservationCalendar from './components/ReservationCalendar/ReservationCalendar';
import ReservationSlotDetailDialog from './components/ReservationSlotDetailDialog/ReservationSlotDetailDialog';
// import { IState as IContactState } from '../../common/store/contacts/state';
// import { IActions as IContactActions, actionCreator as contactActionCreator } from '../../common/store/contacts/actions/creators';

interface IProps extends IActions, IState, StyledComponentProps, IMediaQueryProps {
    roomList: SelectItem[];
    roomSelected: SelectItem;
    navigateTo: (path: string) => void;
    match: {
        params: {
            id: string
        }
    }
}

interface IInternalState {
    openDialog: boolean;
    filterDaySelected: Date,
    reservationSlot?: reservationSlot;
    reservationRoom?: reservationRoom;
}

class ReservationContainer extends React.Component<IProps, IInternalState>
{
    /**
     *
     */
    constructor(p, c) {
        super(p, c);
        this.state = {
            openDialog: false,
            filterDaySelected: p.daySelecte,
            reservationSlot: undefined,
            reservationRoom: undefined,
        }
    }

    componentDidMount() {
        this.props.loadRooms();
        if (this.props.roomSelected) {
            this.loadReservationRoom(this.props.viewType, this.props.dayView)
        }
    }

    loadReservationRoom = (newType: "day" | "week", date?: Date, roomSelected?: SelectItem) => {
        if (!this.props.areLoadingReservationRooms && (this.props.roomSelected || roomSelected)) {
            let room = roomSelected ? roomSelected : this.props.roomSelected;
            this.props.loadReservationRoom(room.value, date ? date : this.props.dayView, newType);
        }
    }
    selectRoom = (selected: SelectItem) => {
        this.props.setRoomSelected(selected);
        this.loadReservationRoom(this.props.viewType, this.state.filterDaySelected, selected);
    }

    updateViewType = (newType: "day" | "week") => {
        this.props.updateViewType(newType)
        if (this.props.roomSelected) {
            this.loadReservationRoom(newType)
        }
    }

    showReservationSlotDetail = (reservationSlot: reservationSlot, reservationRoom: reservationRoom) => {
        this.props.loadReservationsSlot(reservationSlot, reservationRoom);
        this.setState({
            openDialog: true,
            reservationSlot: reservationSlot,
            reservationRoom: reservationRoom,
        })
    }

    closeReservationSlotDialog = () => {
        //refresh
        this.loadReservationRoom(this.props.viewType);
        //reset respoonse
        if (this.props.reservationResponse) {
            this.props.resetResponse();
        }
        this.setState({
            openDialog: false,
            reservationSlot: undefined,
            reservationRoom: undefined,
        })
    }

    onAddConfirm = (reservation: reservation) => {
        let reservationToAdd: reservation = {
            ...reservation,
            roomId: this.state.reservationRoom.roomId,
            duration: this.state.reservationSlot.duration,
            reservationStart: this.state.reservationSlot.startingTime,
            dayCode: this.state.reservationRoom.dayCode,
            reservationEnd: moment(this.state.reservationSlot.startingTime).add(this.state.reservationSlot.duration, "minute").toDate(),
            reservationTimestamp: new Date()
        }
        this.props.addReservation(reservationToAdd).then(resp => {
            if (resp.result) {
                this.loadReservationRoom(this.props.viewType)
            }
        });
    }
    onDeleteConfirm = (reservationId: string, userId: string) => {
        let reservationToDelete: reservation = {
            _id: reservationId,
            userId: userId,
            roomId: this.state.reservationRoom.roomId,
            duration: this.state.reservationSlot.duration,
            reservationStart: this.state.reservationSlot.startingTime,
            dayCode: this.state.reservationRoom.dayCode,
            reservationEnd: moment(this.state.reservationSlot.startingTime).add(this.state.reservationSlot.duration, "minute").toDate(),
            reservationTimestamp: new Date()
        }
        this.props.deleteReservation(reservationToDelete).then(resp => {
            if (resp.result) {
                this.loadReservationRoom(this.props.viewType)
            }
        });
    }

    updateFilterDate = (date: Date) => {
        if (moment(date).isValid()) {
            this.setState({
                filterDaySelected: date
            })
            this.props.setDaySelected(date)
            this.loadReservationRoom(this.props.viewType, date)
        }
    }



    render() {
        return (
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Filters
                        disabled={this.props.areLoadingReservationRooms}
                        roomList={this.props.roomList}
                        roomSelected={this.props.roomSelected}
                        setRoomSelected={this.selectRoom}
                        dayView={this.props.dayView}
                        filterDate={this.state.filterDaySelected}
                        viewType={this.props.viewType}
                        setFilterDate={this.updateFilterDate}
                        classes={this.props.classes}
                        smallScreen={this.props.smallScreen} />
                </Grid>
                <Grid item xs={12} className={this.props.classes.reservationPaperContainer}>
                    <Paper title='Elenco Prenotazioni' fullHeight>
                        {this.props.reservationRooms && this.props.reservationRooms.length > 0 ?
                            < ReservationCalendar
                                roomSelected={this.props.roomSelected}
                                dayView={this.props.dayView}
                                filterDate={this.state.filterDaySelected}
                                updateViewType={this.updateViewType}
                                viewType={this.props.viewType}
                                setFilterDate={this.updateFilterDate}
                                loadReservationRoom={this.loadReservationRoom}
                                classes={this.props.classes}
                                smallScreen={this.props.smallScreen}
                                disabled={this.props.areLoadingReservationRooms}
                                showReservationSlotDetail={this.showReservationSlotDetail}
                                reservationRooms={this.props.reservationRooms} />
                            : <div></div>}
                    </Paper>
                </Grid>
                <ReservationSlotDetailDialog
                    classes={this.props.classes}
                    open={this.state.openDialog}
                    addInProgress={this.props.addingReservation}
                    reservations={this.props.reservations}
                    onDeleteReservation={this.onDeleteConfirm}
                    reservationResponse={this.props.reservationResponse}
                    deleteInProgress={this.props.deletingReservation}
                    resetResponseState={this.props.resetResponse}
                    loadingReservations={this.props.loadingReservations}
                    onCancel={this.closeReservationSlotDialog}
                    reloadSlotDetail={() => this.showReservationSlotDetail(this.state.reservationSlot, this.state.reservationRoom)}
                    onConfirm={this.onAddConfirm}
                    reservationSlot={this.state.reservationSlot} />
            </Grid>
        );
    }
}

const mapStateToProps = (state: IApplicationState) => ({
    ...state.reservations,
    ...state.contacts
})

const mapDispatchToProps = (dispatch: any) => {
    return {
        ...actionCreator(dispatch),
        navigateTo: authActions(dispatch).navigateTo
    }
};

export const Reservations = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles as any)(WithMediaQuery(ReservationContainer)));